import { render, staticRenderFns } from "./UserCreateUpdateDialog.vue?vue&type=template&id=01095dee&scoped=true"
import script from "./UserCreateUpdateDialog.vue?vue&type=script&lang=js"
export * from "./UserCreateUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01095dee",
  null
  
)

export default component.exports